import React, { FC, useEffect, useState } from 'react';
import { Resizer } from './Resizer';
import { INITIAL_IMAGES_VIEW_WIDTH, MAX_IMAGES_VIEW_WIDTH, MIN_IMAGES_VIEW_WIDTH } from './Helpers';
import Images from './Images/Images';
import AnnotationsOverview from './AnnotationsOverview/AnnotationsOverview';
import { ArrowIconLeft } from './ArrowIconLeft';
import styles from './Annotation.module.scss';
import { PathContextType } from './annotation.types';
import ImagesTreeView from './Images/ImagesTreeView';

type Props = {
  hideStichedView: boolean;
  hideTree: boolean;
  loaded: boolean;
  fullScreenMode: boolean;
  treeWidth: number;
  image: any;
  pathContext: PathContextType;
  showImagesAsTree: boolean;
  setHideStichedView: (value: boolean) => void;
};

export const SelectedNode: FC<Props> = ({
  pathContext,
  hideTree,
  hideStichedView,
  loaded,
  fullScreenMode,
  treeWidth,
  image,
  showImagesAsTree,
  setHideStichedView
}) => {
  const [imagesHovered, setImagesHovered] = useState(false);
  const [width, setWidth] = React.useState(INITIAL_IMAGES_VIEW_WIDTH);

  useEffect(() => {
    setWidth(pathContext === 'no-images' ? 0 : INITIAL_IMAGES_VIEW_WIDTH);
  }, [pathContext]);

  const imagesView = showImagesAsTree ? <ImagesTreeView /> : <Images />;

  return (
    <div className={styles.content}>
      <Resizer
        fullScreenMode={fullScreenMode}
        hideStichedView={hideStichedView}
        widthProp={width}
        enable={loaded && !!image}
        maxWidth={pathContext === 'no-images' ? 0 : MAX_IMAGES_VIEW_WIDTH}
        minWidth={pathContext === 'no-images' ? 0 : MIN_IMAGES_VIEW_WIDTH}
        setHideStichedView={setHideStichedView}
        setWidth={setWidth}
        left={true}
      >
        <div onMouseEnter={() => setImagesHovered(true)} onMouseLeave={() => setImagesHovered(false)}>
          {imagesView}
          <ArrowIconLeft
            isVisible={imagesHovered}
            isImageLoaded={loaded && image}
            right='-14.5px'
            top='1.5%'
            fullscreen={fullScreenMode}
            OnChangeTreeAndViewImage={setHideStichedView}
            treeOrViewImage={hideStichedView}
          />
        </div>
      </Resizer>
      <AnnotationsOverview treeWidth={treeWidth} stitchedViewWidth={width} hideTree={hideTree} hideStichedView={hideStichedView} image={image} />
    </div>
  );
};

export default SelectedNode;
